import type { UserProfile } from "@/api/types";

export const PROFILE_NAME_PATH = "/setup/name";

// Email magic-link accounts arrive without a name; Google accounts bring one.
// Gating on the missing name (not the sign-in method) also catches older
// accounts and stops asking once the name is saved.
export function needsProfileName(user: UserProfile | null): boolean {
  return user !== null && !user.display_name?.trim();
}

export function profileNamePathFor(destination: string): string {
  return `${PROFILE_NAME_PATH}?redirect=${encodeURIComponent(destination)}`;
}
